import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import EditMutation from 'mutations/space/edit';
import Form from 'components/space/form';

const Edit = ({ handleClose, onSuccess, space }) => {
  const setError = useError();

  const [editMutation, { loading }] = useMutation(EditMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.space.edit');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.space.edit" />
      </ModalTypography>
      <Form
        initialValues={{ name: space.name }}
        originalName={space.name}
        processing={loading}
        onSubmit={(values) => editMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Edit;
